import { PaletteMode } from '@mui/material';
import { MouseEvent, useCallback, useMemo, useState } from 'react';
import { useGlobalStore } from 'src/store';

const themeOptions: { label: string; value: PaletteMode | null; icon: string }[] = [
  {
    value: 'light',
    label: 'Light',
    icon: 'light_mode',
  },
  {
    value: 'dark',
    label: 'Dark',
    icon: 'dark_mode',
  },
  {
    value: null,
    label: 'Auto',
    icon: 'contrast',
  },
];

const themeOptionsMap = new Map(themeOptions.map((i) => [i.value, i]));

export const useThemeSwitch = () => {
  const forceThemeMode = useGlobalStore.use.forceThemeMode();
  const setForceThemeMode = useGlobalStore.use.setForceThemeMode();

  const [themeModalAnchor, setThemeModalAnchor] = useState<HTMLElement | null>(null);

  const openThemeSwitch = useCallback(
    (event: MouseEvent<HTMLElement>) => setThemeModalAnchor(event.currentTarget),
    [],
  );

  const closeThemeSwitch = useCallback(() => setThemeModalAnchor(null), []);

  const selectedTheme = useMemo(() => themeOptionsMap.get(forceThemeMode), [forceThemeMode]);

  return {
    forceThemeMode,
    setForceThemeMode,
    themeModalAnchor,
    openThemeSwitch,
    closeThemeSwitch,
    themeOptions,
    selectedTheme,
  };
};
